import jssVariables from "../../jss_setup";

export const navbar = {
  menu: {
    background: jssVariables.colors.base_color,
  },
  logo: {
    height: jssVariables.double_gap,
  },
  burgerBtn: {
    border: "none",
    fontSize: "xx-large",
  },
  menuItem: {
    "& h4": {
      fontWeight: "bold",
    },
  },
  ProfileComp: {
    "& h4": {
      fontWeight: 500,
    },
  },
  item: {
    smallscreen: {
      fontSize: "medium",
      fontWeight: 500,
      "& strong": {
        fontWeight: 500,
      },
    },
  },
  profileItem: {
    smallscreen: {
      fontSize: "small",
      fontWeight: 600,
    },
  },
  icon: {
    borderRadius: jssVariables.half_gap,
    smallscreen: {
      borderRadius: `calc(${jssVariables.normal_gap} / 3)`,
    },
  },
};

export const languageModal = {
  mainPanel: {},
  headerPanel: {},
  header: {
    display: "none",
  },
  closeIconSpan: {
    justifySelf: "end",
  },
  closeIcon: {
    color: "white",
    fontSize: "xx-large",
    marginLeft: jssVariables.normal_gap,
  },
  linksPanel__: {
    background: "white",
    gridTemplateColumns: "1fr",
    marginTop: 0,
    marginRight: jssVariables.half_gap,
    overflow: "auto",
    height: "max-content",
    borderRadius: jssVariables.border_radius,
  },
  icon: {
    borderRadius: jssVariables.half_gap,
    height: jssVariables.double_gap,
    width: jssVariables.double_gap,
  },
  link: {
    padding: 0,
  },
  label: {
  },
};
